import _ from 'lodash';
import { Vue } from 'vue-property-decorator';

Vue.filter('get', function (value: any, path: string) {
    return _.get(value, path);
});